import { Timestamp } from 'firebase/firestore';

// eslint-disable-next-line no-shadow
export enum RequestStatus {
  'Processing' = 0,
  'Waiting For Payment',
  'In Progress',
  'Completed',
  'Cancelled',
}

export interface Order {
  id: string;
  userId: string;
  serviceId: string;
  title: string;
  status: RequestStatus;
  vendorId: string | null;

  inputData: Record<string, any>;

  payment: {
    amount: number;
    stripeId: string;
    createdAt: Timestamp;
  };

  createdAt: Timestamp;
  paidAt?: Timestamp;
}
